import React from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { fmtDate } from './NcrShared';

const Mini = ({ title, cols, rows, testid, empty }) => (
  <div data-testid={testid}>
    <p className="text-xs font-semibold mb-1">{title}</p>
    {rows.length === 0 ? <p className="text-xs text-muted-foreground mb-2">{empty}</p> : (
      <table className="w-full text-xs mb-3 border">
        <thead className="bg-muted/50"><tr>{cols.map(([, l]) => <th key={l} className="text-left px-2 py-1 font-medium">{l}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} className="border-t">{cols.map(([k, l, fn]) => <td key={l} className="px-2 py-1">{fn ? fn(r) : r[k] ?? '—'}</td>)}</tr>)}</tbody>
      </table>
    )}
  </div>
);

export const TracePanel = ({ trace = {}, onRefresh, refreshing }) => (
  <Card className="shadow-none" data-testid="complaint-trace-panel">
    <CardHeader className="pb-2 flex-row items-center justify-between space-y-0">
      <CardTitle className="text-sm">Traceability</CardTitle>
      {onRefresh && <Button size="sm" variant="ghost" onClick={onRefresh} disabled={refreshing} data-testid="complaint-trace-refresh-btn"><RefreshCw className={`w-3.5 h-3.5 mr-1 ${refreshing ? 'animate-spin' : ''}`} />Refresh</Button>}
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs mb-3">
        {[['Dispatch challan', trace.dc_number], ['Dispatch date', fmtDate(trace.dispatch_date)], ['Invoice', trace.invoice_number],
          ['Manifest', trace.manifest_number], ['Customer PO', trace.customer_po_number], ['Customer challan', trace.customer_challan_number],
          ['Traceability ID', trace.traceability_id]].map(([l, v]) => (
          <div key={l}><p className="text-muted-foreground">{l}</p><p className="font-mono">{v || '—'}</p></div>
        ))}
      </div>
      <Mini title="Production orders" testid="trace-work-orders" empty="No work order found for this dispatch line"
        rows={trace.work_orders || []} cols={[
          ['wo_number', 'WO', (r) => <Link className="text-blue-700 hover:underline" to={`/production/work-orders?search=${encodeURIComponent(r.wo_number)}`}>{r.wo_number}</Link>],
          ['route_card_number', 'Route card'], ['status', 'Status'], ['quantity', 'Qty'], ['produced_quantity', 'Produced'],
          ['customer_po_number', 'Customer PO']]} />
      <Mini title="Raw material — customer challans" testid="trace-rm-challans" empty="No customer-supplied material linked"
        rows={trace.rm_challans || []} cols={[['challan_number', 'Inbound challan'], ['item', 'Material'], ['quantity', 'Qty'], ['wo_number', 'WO']]} />
      <Mini title="Raw material — purchased lots" testid="trace-purchased-lots" empty="No purchased material lots linked"
        rows={trace.purchased_lots || []} cols={[['reference_number', 'GRN / Invoice'], ['supplier_name', 'Supplier'], ['po_number', 'PO'],
          ['item', 'Material'], ['quantity', 'Qty'], ['received_date', 'Received', (r) => fmtDate(r.received_date)]]} />
      <Mini title="Trace lots" testid="trace-lots" empty="—" rows={trace.trace_lots || []} cols={[['trace_id', 'Trace ID'], ['label', 'Label'], ['wo_number', 'WO']]} />
    </CardContent>
  </Card>
);
